export default __webpack_public_path__ + "static/media/bhajan.a386aa2b.png";